export default {
    sort: {
        asc: 'Asc',
        desc: 'Desc'
    },
    column: {
        hide: 'Hide'
    },
    pagination: {
        totalRowsText: 'row(s) total',
        rowsPerPage: 'Rows per page',
        pageOf: 'Page {current} of {total}',
        first: 'Go to first page',
        previous: 'Go to previous page',
        next: 'Go to next page',
        last: 'Go to last page'
    },
    search: 'Search all columns...',
    view: 'View',
    toggleColumns: 'Toggle columns',
    reset: 'Reset',
    noResults: 'No results.',
    filter: {
        title: 'Filters',
        open: 'Open filters',
        available: 'Available filters',
        active: 'Active',
        back: 'Back to filter fields',
        clear: 'Clear',
        clearAll: 'Clear all',
        remove: 'Remove {filter} filter',
        searchFields: 'Search filters...',
        searchValues: 'Search values...',
        noFields: 'No filters found.',
        selected: 'selected',
        noResults: 'No results found.',
        reset: 'Reset filters',
        date: 'Date',
        numberRange: 'Number Range',
        numericRules: 'Amount Rules',
        pressEnter: 'Press Enter to apply',
        numberFrom: 'Number from',
        numberTo: 'Number to',
        numberResetHint: 'Reset also switches date to Today',
        billingView: 'Billing View'
    }
} 